import { useState } from "react";
import { FormattedMessage, IntlShape } from "react-intl";
type Props = {
  intl: IntlShape;
  heardAbout: string;
  handleChange: (id: string, value: string) => void;
  heardAboutValidationError: boolean;
  setHeardAboutValidationError: (heardAboutValidationError: boolean) => void;
  listOfHeardAbout: {
    id: string;
    name: string;
  }[];
  heardAboutOther: string;
};

const HeardAbout = ({
  intl,
  heardAbout,
  handleChange,
  heardAboutValidationError,
  setHeardAboutValidationError,
  listOfHeardAbout,
  heardAboutOther,
}: Props) => {
  const [errorHeardAbout, setErrorHeardAbout] = useState<string>("");

  const validateHeardAbout = (id: string, value: string) => {
    // value is from drop down
    if (
      value ===
      intl.formatMessage({
        id: "home-register-select-heard-about-us",
      })
    ) {
      setErrorHeardAbout(
        intl.formatMessage({
          id: "Required",
        })
      );
    } else {
      setErrorHeardAbout("");
      setHeardAboutValidationError(false);
    }
  };

  return (
    <div className="form-details__row">
      <div>
        <FormattedMessage tagName="label" id="hear-about-3ET" />
        <span className="required">*</span>
      </div>

      <div className="form-details__row--input">
        <select
          className={`form-control ${errorHeardAbout ? "error" : ""}`}
          onChange={e => handleChange("heardAbout", e.target.value)}
          id="heardAbout"
          onBlur={e => validateHeardAbout("heardAbout", e.target.value)}
          value={heardAbout.startsWith("other") ? "other" : heardAbout}
        >
          {
            <option
              value={intl.formatMessage({
                id: "home-register-select-heard-about-us",
              })}
            >
              <FormattedMessage id="home-register-select-heard-about-us" />
            </option>
          }
          {listOfHeardAbout &&
            listOfHeardAbout.map((heardAbout, index) => (
              <option key={heardAbout.id} value={heardAbout.name}>
                {heardAbout.name}
              </option>
            ))}
          <option value={"other"}>
            <FormattedMessage id="register-heardaboutusoptions-other" />
          </option>
        </select>
      </div>
      <div>
        {errorHeardAbout && (
          <span className="error-message">{errorHeardAbout}</span>
        )}
      </div>
      <div className="form-details__row--input form-details__row--input--other">
        {heardAbout.startsWith("other") && (
          <textarea
            placeholder={intl.formatMessage({
              id: "register-heardaboutus-specify",
            })}
            value={heardAboutOther}
            onChange={e => {
              handleChange("heardAboutOther", e.target.value);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default HeardAbout;
